import type { ScoreState } from "./constants";

const DEPTH_SLICE = 10;
const POINTS_PER_SLICE = 10;
const PLOW_BASE_SCORE = 100;
export function scoreMultiplierForPatents(patentCount: number): number {
  if (patentCount >= 3) return 2;
  if (patentCount === 2) return 1.5;
  if (patentCount === 1) return 1.25;
  return 1;
}

export function createScoreState(startY: number): ScoreState {
  return {
    score: 0,
    maxDepth: startY,
    nextDepthSlice: startY + DEPTH_SLICE,
    combo: 0,
  };
}

export function scoreDepth(state: ScoreState, y: number, multiplier = 1): number {
  if (y <= state.maxDepth) return 0;
  state.maxDepth = y;

  let awarded = 0;
  while (state.nextDepthSlice <= y) {
    const points = Math.ceil(POINTS_PER_SLICE * multiplier);
    state.score += points;
    awarded += points;
    state.nextDepthSlice += DEPTH_SLICE;
  }
  return awarded;
}

export function scorePlow(state: ScoreState, multiplier = 1): number {
  state.combo += 1;
  const points = Math.ceil(PLOW_BASE_SCORE * state.combo * multiplier);
  state.score += points;
  return points;
}

export function resetCombo(state: ScoreState): void {
  state.combo = 0;
}
